import { useNavigate } from "react-router-dom";
import { content } from "../../../data/content";

import { JsonCard } from "../../Card/JsonCard/JsonCard";
import { ListCard } from "../../Card/ListCard/ListCard";

import styles from "./AboutGrid.module.scss";

export function AboutGrid({}) {
  const navigate = useNavigate();
  const c = content;

  return (
    <section className={styles.aboutGrid}>
      <JsonCard
        label="about.ts"
        labelType="free"
        comment="learning out loud, mostly frontend."
        jsonContent={{
          name: "Michelle",
          based: "Koblenz",
          open_to: "Junior roles",
          available_from: "October 2026",
          skills: ["TypeScript", "React"],
          learning: ["Node.js", "Express.js", "SQLite"],
          interests: ["Web development", "Design", "Learning new things"],
        }}
        hasButton
        buttonType="link"
        buttonText="full /about →"
        buttonOnClick={() => navigate("/about")}
      />

      <ListCard
        label="currently"
        labelType="dot"
        title="what I am doing"
        items={[
          `${c.nowLong.sections[1].items[0]}`,
          `${c.nowLong.sections[1].items[1]}`,
          `${c.nowLong.sections[1].items[2]}`,
        ]}
        hasButton
        buttonType="link"
        buttonText="full /now →"
        buttonOnClick={() => navigate("/now")}
      />
    </section>
  );
}
